import React, {
  useEffect,
  useState,
} from "react";

import { createPortal } from "react-dom";

import "./PopupQuestion.css";

import conti from "../imagesHome/conti.png";
import coinImg from "../header/images/coin.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBug } from "@fortawesome/free-solid-svg-icons";

const CLOSE_ANIMATION_DURATION = 280;

const PopupQuestion = ({
  quizExplanation,
  coinCount = 0,
  onRevealAnswer,
  onSpendCoins,

  // Optional:
  // functia care va trimite raportul catre backend
  onReportProblem,

  // Optional:
  // poti trimite chapter, lesson, quiz etc.
  reportContext = {},
}) => {

  const [isVisible, setIsVisible] =
    useState(false);

  const [isOpen, setIsOpen] =
    useState(false);

  const [showExplanation, setShowExplanation] =
    useState(false);

  const [
    explanationPurchased,
    setExplanationPurchased,
  ] = useState(false);

  const [answerRevealed, setAnswerRevealed] =
    useState(false);

  const [
    unlockingExplanation,
    setUnlockingExplanation,
  ] = useState(false);

  const [
    unlockingAnswer,
    setUnlockingAnswer,
  ] = useState(false);


  /* =========================
     RAPORTARE PROBLEMA
  ========================= */

  const [showReportForm, setShowReportForm] =
    useState(false);

  const [reportText, setReportText] =
    useState("");

  const [reportSending, setReportSending] =
    useState(false);

  const [reportSent, setReportSent] =
    useState(false);

  const [reportError, setReportError] =
    useState("");


  const openPopup = () => {
    if (isVisible || isOpen) {
      return;
    }

    setIsVisible(true);

    requestAnimationFrame(() => {
      setIsOpen(true);
    });
  };


  const closePopup = () => {
    if (!isVisible) {
      return;
    }

    setIsOpen(false);

    setShowExplanation(
      explanationPurchased
    );

    setShowReportForm(false);
    setReportText("");
    setReportSending(false);
    setReportSent(false);
    setReportError("");
  };


  const handleBack = () => {

    if (showReportForm) {
      setShowReportForm(false);
      setReportText("");
      setReportSending(false);
      setReportSent(false);
      setReportError("");
      return;
    }

    setUnlockingExplanation(false);
    setUnlockingAnswer(false);
  };


  const handleOpenReport = () => {
    setShowReportForm(true);

    setReportText("");
    setReportSent(false);
    setReportSending(false);
    setReportError("");
  };


const handleSubmitReport = async () => {

  const cleanText =
    reportText.trim();

  if (cleanText.length < 5) {
    setReportError(
      "Descrie putin mai detaliat problema."
    );
    return;
  }

  setReportSending(true);
  setReportError("");

  try {

    const payload = {
      message: cleanText,

      page:
        typeof window !== "undefined"
          ? window.location.href
          : "",

      ...reportContext,
    };


    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/quiz-issue-reports`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );


    const data = await response.json();


    if (!response.ok) {

      throw new Error(
        data?.error ||
        "Raportul nu a putut fi trimis"
      );

    }


    console.log(
      "Raport trimis:",
      data
    );


    setReportSent(true);
    setReportText("");


  } catch (error) {

    console.error(
      "Eroare la raportarea problemei:",
      error
    );

    setReportError(
      "Raportul nu a putut fi trimis. Incearca din nou."
    );

  } finally {

    setReportSending(false);

  }

};

  const handleShowExplanation = () => {
    if (coinCount < 20) {
      setUnlockingExplanation(
        "insufficient"
      );
      return;
    }

    setUnlockingExplanation(true);
  };


  const handleExplanationUnlock = () => {
    setUnlockingExplanation(false);

    setExplanationPurchased(true);

    setShowExplanation(true);

    onSpendCoins?.(20);
  };


  const handleOpenAnswerPurchase = () => {
    if (coinCount < 30) {
      setUnlockingAnswer(
        "insufficient"
      );
      return;
    }

    setUnlockingAnswer(true);
  };


  const handleConfirmAnswer = () => {
    setAnswerRevealed(true);

    setShowExplanation(true);

    setUnlockingAnswer(false);

    onSpendCoins?.(30);

    onRevealAnswer?.();

    closePopup();
  };


  /* =========================
     RESET LA QUIZ NOU
  ========================= */

  useEffect(() => {

    setIsVisible(false);
    setIsOpen(false);

    setShowExplanation(false);

    setExplanationPurchased(false);

    setAnswerRevealed(false);

    setUnlockingExplanation(false);
    setUnlockingAnswer(false);

    setShowReportForm(false);
    setReportText("");
    setReportSending(false);
    setReportSent(false);
    setReportError("");

  }, [quizExplanation]);


  /* =========================
     ANIMATIE INCHIDERE
  ========================= */

  useEffect(() => {

    if (!isVisible || isOpen) {
      return undefined;
    }

    const timer =
      window.setTimeout(() => {
        setIsVisible(false);
      }, CLOSE_ANIMATION_DURATION);

    return () => {
      window.clearTimeout(timer);
    };

  }, [
    isVisible,
    isOpen
  ]);


  /* =========================
     RESET DUPA INCHIDERE
  ========================= */

  useEffect(() => {

    if (isVisible) {
      return;
    }

    setAnswerRevealed(false);

    setUnlockingExplanation(false);
    setUnlockingAnswer(false);

    setShowReportForm(false);

    setReportText("");
    setReportSending(false);
    setReportSent(false);
    setReportError("");

  }, [isVisible]);


  /* =========================
     BLOCARE SCROLL
  ========================= */

  useEffect(() => {

    if (!isVisible) {
      return undefined;
    }

    const previousBodyOverflow =
      document.body.style.overflow;

    const previousHtmlOverflow =
      document.documentElement
        .style.overflow;

    const previousBodyPaddingRight =
      document.body.style.paddingRight;

    const scrollbarWidth =
      window.innerWidth -
      document.documentElement.clientWidth;


    document.body.classList.add(
      "quiz-active"
    );

    document.documentElement
      .classList.add(
        "quiz-active"
      );


    document.body.style.overflow =
      "hidden";

    document.documentElement
      .style.overflow =
      "hidden";


    if (scrollbarWidth > 0) {

      document.body.style
        .paddingRight =
        `${scrollbarWidth}px`;

    }


    return () => {

      document.body.classList.remove(
        "quiz-active"
      );

      document.documentElement
        .classList.remove(
          "quiz-active"
        );

      document.body.style.overflow =
        previousBodyOverflow;

      document.documentElement
        .style.overflow =
        previousHtmlOverflow;

      document.body.style
        .paddingRight =
        previousBodyPaddingRight;

    };

  }, [isVisible]);


  /* =========================
     ESCAPE
  ========================= */

  useEffect(() => {

    if (!isVisible) {
      return undefined;
    }


    const handleKeyDown = (
      event
    ) => {

      if (event.key !== "Escape") {
        return;
      }


      if (
        showReportForm ||
        unlockingExplanation ||
        unlockingAnswer
      ) {

        handleBack();

        return;

      }


      closePopup();

    };


    document.addEventListener(
      "keydown",
      handleKeyDown
    );


    return () => {

      document.removeEventListener(
        "keydown",
        handleKeyDown
      );

    };

  }, [
    isVisible,
    showReportForm,
    unlockingExplanation,
    unlockingAnswer,
  ]);


  /* =========================
     SOLD
  ========================= */

  const renderCoinsInfo = () => (

    <div className="popup-question-coins-info">

      <img
        src={coinImg}
        className="popup-coin-icon"
        alt="Monede"
      />

      <span>
        Sold: {coinCount}
      </span>

    </div>

  );


  /* =========================
     CONTI + BULA
  ========================= */

  const renderMascotMessage = (
    content
  ) => (

    <div className="popup-question-mascot">

      <img
        src={conti}
        className="popup-question-conti"
        alt="Conti"
      />

      <div className="popup-question-bubble">

        {content}

      </div>

    </div>

  );


  /* =========================
     AM INTELES
  ========================= */

  const renderAckButton = () => (

    <div className="popup-question-btns">

      <button
        type="button"
        className={[
          "popup-question-btn",
          "popup-question-btn--ack",
        ].join(" ")}
        onClick={closePopup}
      >

        <span className="popup-question-btn-label">
          Am inteles
        </span>

      </button>

    </div>

  );


  /* =========================
     FORMULAR RAPORTARE
  ========================= */

  const renderReportForm = () => {

    if (reportSent) {

      return (
        <>
          {renderCoinsInfo()}

          {renderMascotMessage(
            <div className="popup-report-success">

              <p>
                Multumim!
              </p>

              <p>
                Problema a fost raportata.
              </p>

            </div>
          )}

          <div className="popup-question-btns">

            <button
              type="button"
              className={[
                "popup-question-btn",
                "popup-question-btn--ack",
              ].join(" ")}
              onClick={handleBack}
            >
              <span className="popup-question-btn-label">
                Inapoi
              </span>
            </button>

          </div>
        </>
      );

    }


    return (
      <>
        {renderCoinsInfo()}

        {renderMascotMessage(
          <div className="popup-report-title">

            <FontAwesomeIcon
              icon={faBug}
            />

            <p>
              Raporteaza o problema
            </p>

          </div>
        )}


        <div className="popup-report-form">

          <label
            htmlFor="popup-report-text"
            className="popup-report-label"
          >
            Ce problema ai gasit?
          </label>


          <textarea
            id="popup-report-text"
            className="popup-report-textarea"
            value={reportText}
            onChange={(event) => {
              setReportText(
                event.target.value
              );

              if (reportError) {
                setReportError("");
              }
            }}
            placeholder="Descrie problema pe care ai intalnit-o..."
            maxLength={1000}
            rows={5}
          />


          <div className="popup-report-counter">

            {reportText.length}/1000

          </div>


          {reportError && (

            <div className="popup-report-error">

              {reportError}

            </div>

          )}


          <button
            type="button"
            className={[
              "popup-question-btn",
              "popup-question-btn--answer",
            ].join(" ")}
            onClick={handleSubmitReport}
            disabled={
              reportSending ||
              reportText.trim().length < 5
            }
          >

            <span className="popup-question-btn-label">

              {reportSending
                ? "Se trimite..."
                : "Trimite raportul"}

            </span>

          </button>


          <button
            type="button"
            className="popup-report-back-btn"
            onClick={handleBack}
            disabled={reportSending}
          >
            Inapoi
          </button>

        </div>
      </>
    );

  };


  /* =========================
     CONTINUT POPUP
  ========================= */

  const renderPopupContent = () => {

    /*
     * RAPORTAREA ARE PRIORITATE.
     * Continutul popup-ului este inlocuit,
     * dar popup-ul ramane acelasi.
     */

    if (showReportForm) {
      return renderReportForm();
    }


    if (
      unlockingAnswer ===
      "insufficient"
    ) {

      return (
        <>
          {renderCoinsInfo()}

          {renderMascotMessage(
            <p>
              Nu ai suficiente monede
              pentru a cumpara raspunsul.
            </p>
          )}

          {renderAckButton()}
        </>
      );

    }


    if (unlockingAnswer) {

      return (
        <>
          {renderCoinsInfo()}

          {renderMascotMessage(
            <p>
              Raspunsul costa{" "}
              <strong>
                30 monede
              </strong>.
              Doresti sa il cumperi?
            </p>
          )}

          <div className="popup-question-btns">

            <button
              type="button"
              className={[
                "popup-question-btn",
                "popup-question-btn--answer",
              ].join(" ")}
              onClick={
                handleConfirmAnswer
              }
            >
              <span className="popup-question-btn-label">
                Cumpara
              </span>
            </button>

          </div>
        </>
      );

    }


    if (
      unlockingExplanation ===
      "insufficient"
    ) {

      return (
        <>
          {renderCoinsInfo()}

          {renderMascotMessage(
            <p>
              Nu ai suficiente monede
              pentru a cumpara explicatia.
            </p>
          )}

          {renderAckButton()}
        </>
      );

    }


    if (unlockingExplanation) {

      return (
        <>
          {renderCoinsInfo()}

          {renderMascotMessage(
            <p>
              Explicatia costa{" "}
              <strong>
                20 monede
              </strong>.
              Doresti sa o cumperi?
            </p>
          )}

          <div className="popup-question-btns">

            <button
              type="button"
              className={[
                "popup-question-btn",
                "popup-question-btn--answer",
              ].join(" ")}
              onClick={
                handleExplanationUnlock
              }
            >
              <span className="popup-question-btn-label">
                Cumpara
              </span>
            </button>

          </div>
        </>
      );

    }


    return (
      <>
        {renderCoinsInfo()}


        {renderMascotMessage(

          showExplanation ? (

            <div
              className="popup-question-explanation-content"
              dangerouslySetInnerHTML={{
                __html:
                  quizExplanation ||
                  "<p>Explicatia nu este disponibila pentru acest quiz.</p>",
              }}
            />

          ) : (

            <div className="popup-question-blocked-row">

              <p className="popup-question-blocked-text">
                Ai ramas blocat?
              </p>


              <button
                type="button"
                className="popup-question-report-btn"
                onClick={
                  handleOpenReport
                }
                aria-label="Raporteaza o problema"
                title="Raporteaza o problema"
              >

                <FontAwesomeIcon
                  icon={faBug}
                />

                <p>
                  Raporteaza
                </p>

              </button>

            </div>

          )

        )}


        <div className="popup-question-btns">

          {!answerRevealed &&
            !showExplanation && (
              <>

                <button
                  type="button"
                  className={[
                    "popup-question-btn",
                    "popup-question-btn--hint",
                  ].join(" ")}
                  onClick={
                    handleShowExplanation
                  }
                >
                  <span className="popup-question-btn-label">
                    Vezi explicatia
                  </span>
                </button>


                <div className="popup-question-or">
                  sau
                </div>


                <button
                  type="button"
                  className={[
                    "popup-question-btn",
                    "popup-question-btn--answer",
                  ].join(" ")}
                  onClick={
                    handleOpenAnswerPurchase
                  }
                >
                  <span className="popup-question-btn-label">
                    Vezi raspunsul
                  </span>
                </button>

              </>
            )}


          {!answerRevealed &&
            showExplanation && (
              <>

                <button
                  type="button"
                  className="popup-question-subtle-answer-btn"
                  onClick={
                    handleOpenAnswerPurchase
                  }
                >
                  Nu este suficient de clar?
                  Poti cumpara raspunsul
                </button>


                <button
                  type="button"
                  className={[
                    "popup-question-btn",
                    "popup-question-btn--ack",
                  ].join(" ")}
                  onClick={closePopup}
                >
                  <span className="popup-question-btn-label">
                    Am inteles
                  </span>
                </button>

              </>
            )}

        </div>
      </>
    );

  };


  /* =========================
     PORTAL
  ========================= */

  const popup =
    isVisible &&
    typeof document !==
      "undefined"
      ? createPortal(
          <>
            <div
              className={[
                "popup-question-overlay",
                isOpen
                  ? "open"
                  : "",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={closePopup}
              aria-hidden="true"
            />


            <div
              className={[
                "popup-question",
                isOpen
                  ? "open"
                  : "",
              ]
                .filter(Boolean)
                .join(" ")}
              role="dialog"
              aria-modal="true"
              aria-label="Ajutor pentru lectie"
            >


              <button
                type="button"
                className={[
                  "popup-question-close",

                  showReportForm ||
                  unlockingExplanation ||
                  unlockingAnswer
                    ? "popup-question-close--text"
                    : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
                onClick={
                  showReportForm ||
                  unlockingExplanation ||
                  unlockingAnswer
                    ? handleBack
                    : closePopup
                }
                aria-label={
                  showReportForm ||
                  unlockingExplanation ||
                  unlockingAnswer
                    ? "Inapoi"
                    : "Inchide"
                }
              >

                {showReportForm ||
                unlockingExplanation ||
                unlockingAnswer
                  ? "Inapoi"
                  : "×"}

              </button>


              <div className="popup-question-content">

                {renderPopupContent()}

              </div>

            </div>

          </>,
          document.body
        )
      : null;


  return (
    <>
      <div className="popup-question-container">

        <button
          type="button"
          className="oriented-question-track"
          onClick={
            isOpen
              ? closePopup
              : openPopup
          }
          aria-label="Deschide ajutor"
          aria-expanded={isOpen}
        >

          <span className="help-icon">
            ?
          </span>

          <span className="help-text">
            HELP
          </span>

        </button>

      </div>

      {popup}
    </>
  );

};

export default PopupQuestion;